// main.js
import $ from "jquery";
import AppView from "./app";

$(function () {
  var view = new AppView();
});
